import {h, Fragment} from "preact"
import { RangeSlider, useRangeSlider } from "@nosto/preact"
import { useEffect, useRef, useState, useMemo } from "preact/hooks";
import RangeInput from "./elements/RangeInput"

export default function RangeFacet({ facet, activeFacet, handleFacetToggle }) {
    const { min, max, range, updateRange } = useRangeSlider(facet.id);
    const [ active, setActive ] = useState(false);
    const [ dropdownHeight, setDropdownHeight ] = useState(0);
    const dropdownRef = useRef(null);
    
    const desktopActive = activeFacet === facet.id;
    const isActive = window.innerWidth >= 1240 ? desktopActive : active;

    useEffect(() => {
        if(dropdownRef?.current) {
            requestAnimationFrame(() => {
                if(dropdownRef?.current) {
                    const element = dropdownRef.current;
                    const originalMaxHeight = element.style.maxHeight;
                    const originalHeight = element.style.height;
                    
                    element.style.maxHeight = 'none';
                    element.style.height = 'auto';
                    
                    const naturalHeight = element.scrollHeight;
                    
                    element.style.maxHeight = originalMaxHeight;
                    element.style.height = originalHeight;
                    
                    setDropdownHeight(naturalHeight);
                }
            });
        }
    }, [ dropdownRef?.current, facet ]);

    const toggleActive = () => {
        setActive(prev => !prev);
    }

    const handleClick = () => {
        if(window.innerWidth >= 1240) {
            handleFacetToggle(facet.id);
        } else {
            toggleActive();
        }
    }

    return (
        <li class="ns-facet ns-range-facet">
            <button
                type="button"
                class="ns-facet-toggle ns-w-100 ns-flex ns-flex-nowrap ns-items-center ns-justify-between"
                data-nosto-element="facet"
                onClick={handleClick}
                aria-controls={`ns-${facet.id}-sub-menu`}
                aria-expanded={isActive}
                aria-label={`${isActive ? 'Collapse' : 'Expand' } ${facet.name}`}
            >
                <h3 id={`ns-${facet.id}-title`}>
                    {facet.name}
                </h3>
                <span 
                    aria-hidden="true" 
                    role="presentation" 
                    class="ns-plus-minus-icon ns-relative"
                />
            </button>
            <div 
                class="ns-facet-body"
                id={`ns-${facet.id}-sub-menu`}
                aria-labelledby={`ns-${facet.id}-title`}
                aria-hidden={!isActive}
                style={`--dropdown-height: ${dropdownHeight}px;`} // css transition
                ref={dropdownRef}
            >
                <div class="ns-range-body">
                    <div class="ns-flex ns-justify-between">
                        <div class="">
                            <label for={`ns-${facet.id}-min`} class="ns-form-label">
                                Min.
                            </label>
                            <RangeInput
                                id={`ns-${facet.id}-min`}
                                min={min}
                                max={max}
                                range={range}
                                value={range[0]}
                                onChange={e => {
                                    const value = parseFloat(e.currentTarget.value) || undefined
                                    updateRange([value, range[1]])
                                }}
                            />
                        </div>
                        <div class="">
                            <label for={`ns-${facet.id}-max`} class="ns-form-label">
                                Max.
                            </label>
                            <RangeInput
                                id={`ns-${facet.id}-max`}
                                min={min}
                                max={max}
                                range={range}
                                value={range[1]}
                                onChange={e => {
                                    const value = parseFloat(e.currentTarget.value) || undefined
                                    updateRange([range[0], value])
                                }}
                            />
                        </div>
                    </div>
                    <RangeSlider id={facet.id} />
                </div>
            </div>
        </li>
    )
}
